const component = require('../component/component');

const itemsList = Object.assign({}, component, {
    subelements: {
        table: null,
        filtersRow: null,
        actionsTh: null,
        actionsFilterRowTd: null,
        secondaryFiltersToggler: false,
        exportFiltersToggler: false,
        settingsFiltersToggler: false,
        appliedFilters: false,
        // Master "select all" checkbox in the table header (only emitted
        // when hasActions.selected is true). null default so hasSubelement()
        // correctly reports absence when the column isn't rendered.
        selectAllCheckbox: null
    },
    enableSort: false,
    sortable: false, //sortable object
    controller: null,
    action: 'items',
    forAction: null,
    colsAliases: [],
    hasActions: {
        general: false,
        selected: false,
        items: false
    },
    hasSubcomponents: {
        primary: false,
        secondary: false,
        export: false,
        settings: false,
        columns: false,
        pagination: false
    },
    subComponents: [],

    init: function () {
        component.init.call(this);

        if (this.hasSubelement('secondaryFiltersToggler')) {
            this.subelements.secondaryFiltersToggler.onclick = () => { this.toggleAside('secondary'); return false; };
        }

        if (this.hasSubelement('exportFiltersToggler')) {
            this.subelements.exportFiltersToggler.onclick = () => { this.toggleAside('export'); return false; };
        }

        if (this.hasSubelement('settingsFiltersToggler')) {
            this.subelements.settingsFiltersToggler.onclick = () => { this.toggleAside('settings'); return false; };
        }

        if (this.hasSubelement('selectAllCheckbox')) {
            this.initSelectAll();
        }

        this.loadItems(this);
    },

    initSelectAll: function () {
        // Local select-all implementation (no KT auto-init dependency).
        // Master toggle drives all per-row checkboxes; row checkboxes update
        // the master's checked / indeterminate state reactively. Per-row
        // checkboxes are identified by their `selectorFor` extra attribute
        // pointing at this list's id (set server-side in generic.php), so
        // the lookup is decoupled from DOM placement and dynamically-added
        // rows are picked up automatically by componentsWithExtra().
        let master = this.subelements.selectAllCheckbox;

        // Suppress the master-state recompute while the master itself is
        // propagating changes to rows — otherwise the table-level handler
        // fires once per row and flickers the indeterminate state.
        let suppressRowReact = false;

        // Resolve the per-row checkbox component instances via the registered
        // `selectorFor` extra. Returns components, not raw inputs — each has
        // .element pointing at the DOM <input>. The PHP side passes
        // get_html_id() (the prefixed html id, including formId prefix) so
        // the value matches `this.id` at runtime.
        let getRowCheckboxes = () => {
            return this.hm.app.componentsWithExtra('selectorFor', this.id);
        };

        // Master change → propagate to all row checkboxes.
        master.addEventListener('change', () => {
            suppressRowReact = true;
            let rowCheckboxes = getRowCheckboxes();
            rowCheckboxes.forEach((rowCheckbox) => {
                // Only flip rows whose state actually differs to avoid
                // dispatching redundant change events.
                if (rowCheckbox.element.checked !== master.checked) {
                    rowCheckbox.element.checked = master.checked;
                    // Dispatch change so any downstream listeners (e.g.
                    // action buttons enabling on row-selection count) react.
                    rowCheckbox.element.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
            suppressRowReact = false;
            // Master fully reflects the user's intent — clear any
            // indeterminate state inherited from a prior partial selection.
            master.indeterminate = false;
        });

        // Row change → recompute master state. Listener is at the table level
        // so it catches bubbled change events from any descendant; we then
        // confirm the source is one of our `selectorFor`-tagged checkboxes
        // before recomputing (avoids reacting to other table changes).
        this.subelements.table.addEventListener('change', (e) => {
            if (suppressRowReact) {
                return;
            }
            // Look up the source as a registered component and confirm
            // it's tagged for this list. Skips changes from anything that
            // isn't a row-select checkbox (filters, sub-forms, etc.).
            let sourceComponent = this.hm.app.components[e.target.id];
            if (typeof sourceComponent === typeof undefined ||
                sourceComponent.extraAttributes.selectorFor !== this.id) {
                return;
            }
            let rowCheckboxes = getRowCheckboxes();
            let total = rowCheckboxes.length;
            let checkedCount = 0;
            rowCheckboxes.forEach((rowCheckbox) => {
                if (rowCheckbox.element.checked) {
                    checkedCount++;
                }
            });
            // Indeterminate when some-but-not-all are checked.
            master.indeterminate = checkedCount > 0 && checkedCount < total;
            // Fully checked only when every row is checked (and there's at
            // least one row to check).
            master.checked = total > 0 && checkedCount === total;
        });
    },

    toggleAside: function (asideToToggle) {
        // Resolve a drawer adapter for each filter aside on the page and
        // delegate the open/close decision to it. The adapter encapsulates
        // viewport-driven layout (pinned inline above lg, sliding overlay
        // below) and the global body-dataset state — this loop just dispatches
        // toggle for the active aside and hide for the others.
        let filterAsides = ['secondary', 'export', 'settings'];

        filterAsides.forEach((aside) => {
            let asideEl = document.getElementById(this.id + '_' + aside + '_window');
            if (asideEl === null) {
                return true;
            }

            let drawer = this.hm.behaviors.drawer.get(asideEl);

            if (aside === asideToToggle) {
                drawer.toggle();
            } else {
                drawer.hide();
            }
        });
    },

    clearList: function () {
        // Get a static snapshot via querySelectorAll (NodeList has forEach; HTMLCollection does not).
        // Use row.remove() directly to avoid index-shift issues from live HTMLCollection deletion.
        let rows = this.subelements.table.querySelectorAll('tbody tr');
        rows.forEach((row) => {
            if (typeof row.dataset.zitDontClear === typeof undefined) {
                row.remove();
            }
        });

        if (this.subelements.appliedFilters !== false) {
            /*
            let appliedFiltersList = this.subelements.appliedFilters.querySelector('ul');
            if (appliedFiltersList !== null) {
                appliedFiltersList.remove();
            }
            */
            this.subelements.appliedFilters.innerHTML = '<div class="' + this.hm.app.cssClass('textSizeMedium') + ' zit-display-flex zit-justify-content-center">' + this.hm.app.utext('pleaseWait') + '... <span class="' + this.hm.app.cssClass('loadingSpinner') + ' zit-align-middle zit-ms-2"></span></div>';
        }

        this.removeSubcomponents();

        if (this.enableSort && this.sortable !== false) {
            delete this.sortable;
            this.sortable = false;
        }

        this.dispatch('zitClear', {});
    },

    getItems: async function (resetFilters = false) {
        let formPostData = {
            forAction: this.forAction,
            listConfigHash: this.configHash,
            csrf: this.hm.app.pageToken
        };

        let filters = this.hm.app.componentsWithExtra('filterListId', this.id);

        let filtersFormPostData = {};

        if (resetFilters) {
            filtersFormPostData.resetAllFilters = 1;
        } else {
            filters.forEach((filterComponent) => {
                filtersFormPostData = Object.assign({}, filtersFormPostData, filterComponent.formPostData(filtersFormPostData));
            });
        }

        formPostData = Object.assign({}, formPostData, filtersFormPostData, this.postParams);

        let response = await this.hm.app.fetchJson(this.controller, this.action, formPostData, 'POST');

        return response;
    },

    loadItems: async function (triggerComponent) {
        this.clearList();

        let response = await this.getItems(triggerComponent === 'resetAllFilters');
        //this.hm.log('items list', this.controller, formPostData, response);

        if (typeof response.needsReload !== typeof undefined) {
            window.location.reload(); //if the page should be reloaded is detetermined in the controller; this makes sure the new values of the filters are saved and the page is reloaded with the new filters. Also, when the user reloads the page via the browser's reload button, he will not be asked to resubmit post data
        } else {
            this.itemsActions(response);

            this.displayItems(response);

            // The Draggable library is optional per tier: without it the list
            // still renders, only the row drag-sort is unavailable.
            if (this.enableSort && typeof Draggable !== 'undefined') {
                this.initSortable(this.subelements.table.querySelector('tbody'));
            }

            if (typeof response.appliedFilters !== typeof undefined) {
                await this.appliedFilters(response);
            }

            this.dispatch('zitLoaded', { response: response });
        }
    },

    itemsActions: function (response) {
        this.hasActions.items = this.subelements.filtersRow !== null;

        if (!this.hasActions.items) {
            this.hasActions.items = response.items.some((item) => {
                if (typeof item.actions !== typeof undefined) {
                    if (this.hm.helper.isArray(item.actions) && item.actions.length === 0) {
                        return false;
                    }
                    if (this.hm.helper.isObject(item.actions) && Object.getOwnPropertyNames(item.actions).length > 0) {
                        return true;
                    }
                }
                return false;
            });
        }

        if (this.hasActions.items || this.hasSubcomponents.columns.length > 0) {
            this.hm.helper.showElement(this.subelements.actionsTh);
            if (this.hasSubelement('actionsFilterRowTd')) {
                this.hm.helper.showElement(this.subelements.actionsFilterRowTd);
            }
        } else {
            this.hm.helper.hideElement(this.subelements.actionsTh);
            if (this.hasSubelement('actionsFilterRowTd')) {
                this.hm.helper.hideElement(this.subelements.actionsFilterRowTd);
            }
        }
    },

    displayItems: function (response) {
        if (response.items.length > 0) {
            response.items.forEach((item, index) => {
                let newRow = this.subelements.table.querySelector('tbody').insertRow(-1);

                newRow.dataset.zitItemId = item.itemId;
                newRow.dataset.zitIndex = index;

                if (this.enableSort) {
                    // 'draggable' = third-party Draggable selector, intentionally
                    // un-prefixed (see scripts/behaviors.contract.md "Documented exception").
                    newRow.classList.add('draggable');
                    let sortCell = newRow.insertCell(-1);
                    sortCell.innerHTML = this.getTemplate('sortingHandle');
                }

                if (this.hasActions.selected) {
                    let selectedCell = newRow.insertCell(-1);
                    selectedCell.innerHTML = item.components.selected;
                }

                if (this.hasActions.items) {
                    let actionsCell = newRow.insertCell(-1);
                    let actionsHTML = '';
                    for (let actionName in item.actions) {
                        actionsHTML += item.actions[actionName];
                    }
                    // actions-col is theme-owned (actionsCol zone in itemsList/config.json);
                    // resolve via cssClassesMap so it matches the .tpl-rendered cells. Empty
                    // under tiers without an actions-column class (e.g. Bootstrap).
                    let actionsColClass = this.hm.app.cssClass('actionsCol');
                    if (actionsColClass) {
                        actionsCell.classList.add(...actionsColClass.split(' '));
                    }
                    actionsCell.innerHTML = actionsHTML;
                }

                this.colsAliases.forEach((colAlias) => {
                    let newCell = newRow.insertCell(-1);
                    newCell.innerHTML = item.components[colAlias];
                });

                this.subComponents = this.subComponents.concat(this.hm.app.initComponents(newRow));
            });
        } else {
            let newRow = this.subelements.table.querySelector('tbody').insertRow(-1);
            let newCell = newRow.insertCell(-1);
            newCell.colSpan = this.subelements.table.rows[0].cells.length;
            newCell.innerHTML = this.hm.app.utext('noItemsFound');
        }
    },

    appliedFilters: async function (response) {
        if (this.hm.app.appInitPromise !== false) {
            await this.hm.app.appInitPromise;
        }

        let appliedFiltersNo = 0;
        let appliedFiltersText = this.hm.app.utext('appliedFilters') + ': ';
        for (let filterName in response.appliedFilters) {
            if (['noPP', 'countAccuracy'].includes(filterName)) {
                continue;
            }

            let appliedFilter = response.appliedFilters[filterName];
            if (appliedFilter !== false) {
                appliedFiltersText += this.hm.app.utext(appliedFilter.title) + ': <strong class="' + this.hm.app.cssClass('mutedText') + '">' + appliedFilter.value + '</strong> / ';
                appliedFiltersNo++;
            }
        }

        if (appliedFiltersNo > 0) {
            let resetAllFiltersElement = this.hm.helper.string2element('<a href="#">' + this.hm.app.utext('resetFilters') + '</a>');
            resetAllFiltersElement.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.loadItems('resetAllFilters');
            });

            this.subelements.appliedFilters.innerHTML = appliedFiltersText;
            this.subelements.appliedFilters.append(resetAllFiltersElement);
        } else {
            this.subelements.appliedFilters.innerHTML = '';
        }
    },

    dispatch: function (eventType, data) {
        data.listId = this.id;

        let event = new CustomEvent(eventType, { detail: data });
        document.dispatchEvent(event);
    },

    removeSubcomponents: function () {
        this.hm.app.removeComponents(this.subComponents);
        this.subComponents = [];
    },

    initSortable: function (container) {
        // .draggable / .draggable-handle: selectors for the third-party Shopify
        // Draggable library — intentionally un-prefixed (vendored _draggable.scss
        // styles them + the library emits sibling draggable-* classes we can't
        // rename). See scripts/behaviors.contract.md "Documented exception".
        this.sortable = new Draggable.Sortable(container, {
            draggable: ".draggable",
            handle: ".draggable .draggable-handle",
            mirror: {
                //appendTo: selector,
                appendTo: "body",
                constrainDimensions: true
            }
        });

        this.sortable.on('sortable:start', (e) => { this.clearTimer('saveSort_' + this.id); });

        this.sortable.on("sortable:stop", (e) => {
            this.startTimer('saveSort_' + this.id, () => { this.saveSort(); }, 2500);
            //e.data.oldIndex
            //e.data.newIndex
            //e.data.dragEvent.data.source
        });
    },

    saveSort: async function () {
        this.clearTimer('saveSort_' + this.id);

        let sorted = {};

        let tbody = this.subelements.table.querySelector('tbody');

        tbody.querySelectorAll('tr').forEach((tr, index) => {
            let itemId = parseInt(tr.dataset.zitItemId);
            let currentIndex = parseInt(tr.dataset.zitIndex);

            if (typeof itemId !== typeof undefined && itemId && typeof currentIndex !== typeof undefined && currentIndex !== index) {
                tr.dataset.zitIndex = index;
                sorted[itemId] = index;
            }
        });

        await this.submitSortOrder(sorted);
    },

    // Send the updated sort order to the server
    submitSortOrder: async function (sorted) {
        if (Object.keys(sorted).length > 0) {
            let data = {
                configHash: this.configHash,
                componentAction: 'saveSort',
                sorted: sorted
            };

            let response = await this.hm.app.fetchJson('components', 'main', data);
            //maybe display a message that the new order was saved
        }
    }

});

module.exports = itemsList;